import { useState } from "react";
import AdminSidebar, { type AdminSection } from "./components/AdminSidebar";
import AdminTopBar from "./components/AdminTopBar";
import DashboardSection from "./sections/DashboardSection";
import VenuesSection from "./sections/VenuesSection";
import CategoriesSection from "./sections/CategoriesSection";
import UsersSection from "./sections/UsersSection";
import CampaignsSection from "./sections/CampaignsSection";
import SupportSection from "./sections/SupportSection";
import AdsSection from "./sections/AdsSection";
import { supportTickets } from "../../mocks/adminData";

export default function AdminPage() {
  const [section, setSection] = useState<AdminSection>("dashboard");
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);

  const pendingSupport = supportTickets.filter((t) => t.status === "open").length;

  const renderSection = () => {
    switch (section) {
      case "dashboard":  return <DashboardSection />;
      case "venues":     return <VenuesSection />;
      case "categories": return <CategoriesSection />;
      case "users":      return <UsersSection />;
      case "campaigns":  return <CampaignsSection />;
      case "ads":        return <AdsSection />;
      case "support":    return <SupportSection />;
      default:           return <DashboardSection />;
    }
  };

  const handleNavigate = (s: AdminSection) => {
    setSection(s);
    setMobileSidebarOpen(false);
  };

  return (
    <div className="flex h-screen bg-stone-100 overflow-hidden">
      {/* Desktop Sidebar */}
      <div className="hidden md:flex flex-shrink-0">
        <AdminSidebar
          active={section}
          onNavigate={handleNavigate}
          collapsed={sidebarCollapsed}
          onToggle={() => setSidebarCollapsed(!sidebarCollapsed)}
        />
      </div>

      {/* Mobile Sidebar Overlay */}
      {mobileSidebarOpen && (
        <div
          className="fixed inset-0 bg-black/50 z-50 md:hidden"
          onClick={() => setMobileSidebarOpen(false)}
        >
          <div onClick={(e) => e.stopPropagation()}>
            <AdminSidebar
              active={section}
              onNavigate={handleNavigate}
              collapsed={false}
              onToggle={() => setMobileSidebarOpen(false)}
            />
          </div>
        </div>
      )}

      {/* Main Content */}
      <div className="flex-1 flex flex-col overflow-hidden min-w-0">
        {/* Top bar */}
        <div className="flex items-center bg-white border-b border-stone-100">
          {/* Mobile hamburger */}
          <button
            onClick={() => setMobileSidebarOpen(true)}
            className="md:hidden w-14 h-16 flex items-center justify-center text-stone-500 hover:text-stone-800 transition-colors cursor-pointer flex-shrink-0"
          >
            <i className="ri-menu-line text-xl" />
          </button>
          <div className="flex-1">
            <AdminTopBar section={section} pendingSupport={pendingSupport} />
          </div>
        </div>

        {/* Scrollable content area */}
        <main className="flex-1 overflow-y-auto p-4 md:p-6">
          {renderSection()}
        </main>
      </div>
    </div>
  );
}
